<style>
.example-list {
  width: 500px;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.example-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
              0 8px 10px 1px rgba(0, 0, 0, 0.14),
              0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

</style>
<!-- Container-fluid starts -->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <!--<div class="card-header" style="padding:15px;background-color:#e5e5e5">
                    <h5>Add Product Details</h5>
                </div>-->
                <div class="card-body">			
					 <div class="row" >
					 <div class="u-pearls-xs row mb-12" style="padding-bottom:10px;">
						<div id="1" class="u-pearl current col-3" >
						  <div class="u-pearl-icon" >1</div><!--<span class="u-pearl-title">Page 1</span>-->
						</div>
						<div id="2" class="u-pearl done col-3">
						  <div class="u-pearl-icon">2</div><!--<span class="u-pearl-title">Page 2</span>-->
						</div>
						<div id="3" class="u-pearl done col-3">
						  <div class="u-pearl-icon">3</div><!--<span class="u-pearl-title">Page 3</span>-->
						</div>
						<div id="4" class="u-pearl done col-3">
						  <div class="u-pearl-icon">4</div><!--<span class="u-pearl-title">Page 4</span>-->
						</div>
						
						
					  </div>
						<!--  <div class="u-pearls-xs row mb-12" style="padding-bottom:10px;">
						<div id="13" class="u-pearl disabled col-1">
						  <div class="u-pearl-icon">13</div>
						</div>
						<div id="14" class="u-pearl disabled col-1" >
						  <div class="u-pearl-icon">14</div>
						</div>
						<div id="15" class="u-pearl disabled col-1">
						  <div class="u-pearl-icon">15</div>
						</div>
						<div id="16" class="u-pearl disabled col-1">
						  <div class="u-pearl-icon">16</div>
						</div>
					  </div>-->
					  
					 </div>
					<!--<div class="row">
						<div class="col-sm-12" style="padding-bottom:10px;">
							<a routerLink="/master/VendorRegister" class="btn btn-secondary btn-sm" style="font-size:14px;"> Add New </a> 
						</div>
					</div>
                    <div class="table-responsive">                        											
						<table id="vendortable" class="table table-bordered table-condensed" datatable >
						  <thead>
							<tr>
								<th >Type</th>
								<th >Business Name</th>				  
								<th >Legal Name</th>				  				  			 
								<th >Description</th>
								<th >Vendor ID</th>							  
							</tr>
						  </thead>
						  <tbody>
							<tr *ngFor="let v of vendor">
							  <td>{{ v.business_type_name }}</td>
							  <td>{{ v.vendor_name }}</td>
							  <td>{{ v.vendor_legal_name }}</td>
							  <td>{{ v.vendor_description }}</td>
							  <td>{{ v.vendor_name_id }}</td>
							</tr>
						  </tbody>
						</table>						
                    </div>-->
					
					<div class="row" id="form1" #form1>
						<form  class="needs-validation" novalidate>
						<div class="card">							
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Register Details</h5>
							</div>
							<div class="card-body">
								
								<div class="row">
									<div class="col-md-4 mb-3">
										<label>Type</label>	
										<select class="form-control select btn-square "  name="business_type" placeholder="" required [(ngModel)]="cbusiness_type" [disabled]=true>	
											<option value="">Select</option>
											<option value="0">Individual</option>													
											<option value="1">Organization</option>													
										</select>	
											<!--<div *ngIf="submitted  && registerForm.controls['business_type'].errors" >	
												<div *ngIf="registerForm.controls['business_type'].errors?.['required']" class="text text-danger" >Business Type is required</div>								
											</div>-->
									</div>
									<div class="col-md-4 mb-3">
										<label >Business Vertical Name</label>
										<input class="form-control btn-square" type="text" placeholder="" name="business_vertical_name"  #vendor_name required [(ngModel)]="cbusiness_vertical_name" [disabled]=true>										
									</div>																		
								</div>                        
								   
								<div class="row">                            
									<div class="col-md-12 mb-3">
										<label >Description</label>
										<textarea class="form-control btn-square"  rows="4" type="text"  placeholder="" name="business_vertical_description" required [(ngModel)]="cbusiness_vertical_description" [disabled]=true> </textarea>
										
									</div>
									<div class="col-md-4 mb-3">
										<label >Business Name</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="business_name" required [(ngModel)]="cbusiness_name" [disabled]=true>
										
									</div>
									<div class="col-md-4 mb-3">
										<label >Subdomain for Business</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="business_subdomain" required [(ngModel)]="cbusiness_subdomain" [disabled]=true> 
										
									</div>
									<div class="col-md-4 mb-3">
										<label >Legal Name</label>
										<input class="form-control btn-square" type="text" placeholder="" name="legal_name" required [(ngModel)]="clegal_name" [disabled]=true>
										
									</div>
								</div> 
							</div>
						</div>	
						
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Address</h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-md-3 mb-3">
										<label>Address Line1</label>	
										<input class="form-control btn-square"  type="text" placeholder="" name="addressline1" [(ngModel)]="caddressline1">
									</div>
									<div class="col-md-3 mb-3">
										<label>Address Line2</label>	
										<input class="form-control btn-square"  type="text" placeholder="" name="addressline2" [(ngModel)]="caddressline2">
									</div>
									<div class="col-md-3 mb-3">
										<label >Street No</label>
									   <input class="form-control btn-square"  type="text" placeholder="" name="street_no" [(ngModel)]="cstreet_no"> 	
									</div>
									<div class="col-md-3 mb-3">
										<label >Street Name</label>
										<input class="form-control btn-square"  type="text" placeholder="" name="street_name" [(ngModel)]="cstreet_name">                                
									</div>									
									<div class="col-md-3 mb-3">
										<label >Area</label>
										<input class="form-control btn-square" type="text" name="area_name" placeholder="" required [(ngModel)]="carea_name">											
									</div>
									<div class="col-md-3 mb-3">
										<label >Zip</label>
										<input class="form-control btn-square" type="text" placeholder="" name="zip" required [(ngModel)]="czip">                               										
									</div>
									<div class="col-md-3 mb-3">
										<label >Region</label>
										<input class="form-control btn-square" type="text" name="region_name" placeholder="" [(ngModel)]="cregion_name">	 
									</div>
									<div class="col-md-3 mb-3">
										<label >Province</label>
										<select class="form-control btn-square" name="stateshort" placeholder=""  required (change)="getState($event);" [(ngModel)]="cstateshort">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let state of countryProvinces"  value={{state.shortname}}>{{state.longname}}</option> 
										</select>	 
										
									</div>
									<div class="col-md-3 mb-3">
										<label >Country</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="country"   value={{country}} [disabled]=true >                                
									</div>
								</div>
							</div>			
						</div>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5 >Point of Contact</h5>
							</div>
							<div class="card-body">
								<div class="row">
									
									<div class="col-md-4 mb-3">
										<label >First Name</label>
										<input class="form-control btn-square" type="text" placeholder="" name="admin_first_name" required [(ngModel)]="cadmin_first_name" [disabled]=true>
										
									</div>
									<div class="col-md-4 mb-3">
										<label >Last Name</label>
										<input class="form-control btn-square" type="text" placeholder="" name="admin_last_name" [(ngModel)]="cadmin_last_name" [disabled]=true>
									</div>
									<div class="col-md-4 mb-3">
										<label >Title</label>
										<input class="form-control btn-square" type="text" placeholder="" name="admin_title"  required [(ngModel)]="cadmin_title" [disabled]=true>
										<div *ngIf="submitted && registerForm.controls['admin_title'].errors" >
											<div *ngIf="registerForm.controls['admin_title'].errors?.['required']" class="text text-danger"  >Title is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Gender</label>
										<select class="form-control btn-square" name="admin_gender" placeholder="" required [(ngModel)]="cadmin_gender" [disabled]=true>	
											<option value="">Select</option>                                                                   
											<option value="1">Male</option>                                                                   
											<option value="2">Female</option>                                                                   
											<option value="3">Others</option>                                                                   						
										</select>										
									</div>
									<div class="col-md-4 mb-3">
										<label >Date of Birth</label>
										<input class="form-control btn-square" type="date" placeholder="" name="admin_dob"  min="{{minDobString}}" max="{{maxDobString}}" datetime="yyyy-MM-dd" required [(ngModel)]="cadmin_dob" [disabled]=true>										
									</div>
									<div class="col-md-4 mb-3">
										<label >Phone</label>
										<input class="form-control btn-square" type="number"  placeholder="" name="admin_phone"  required [(ngModel)]="cadmin_phone" [disabled]=true>
										
									</div>
									<div class="col-md-4 mb-3">
										<label >Email ID</label>
										<input class="form-control btn-square" type="email"  placeholder="" name="admin_email"  required [(ngModel)]="cadmin_email" [disabled]=true>										
									</div>									
								</div>
							</div>													
						</div>		
						<div class="row" >                            
							<div class="col-md-12 mb-3" style="text-align:right;">
								<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(1)">Next</button>									
							</div>									
						</div>
						</form>
						</div>						
						
						
						<div class="row" id="form2" style="display:none" >
						<form [formGroup]="cForm" class="needs-validation" novalidate>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Company Information</h5>
							</div>
							<div class="card-body">
								<div class="row">										
									<div class="col-md-3 mb-3">
										<label >Upload Logo *</label>
										<input class="form-control btn-square" type="file" formControlName="logo_upload" placeholder="" name="logo_upload" (change)="selectFile($event)" >
										<!--<div *ngIf="logo_upload==''">
										<div *ngIf="next2Clicked  && cForm.controls['logo_upload'].errors" >	
											<div *ngIf="cForm.controls['logo_upload'].errors?.['required']" class="text text-danger" >Logo is required</div>								
										</div>
										</div>-->
									</div>	
									<div class="col-md-3 mb-3" *ngIf="logo_upload">
										<label >&nbsp;</label>
										<div class="form-control btn-square">{{logo_upload}}</div>							
										
									</div>		
								</div>   
								<div class="row">										
									<div class="col-md-3 mb-3">
										<label >Registration Number</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="registration_number" formControlName="registration_number" [(ngModel)]="registration_number">										
									</div>
									<div class="col-md-3 mb-3">
										<label >Registration Date</label>
										<input class="form-control btn-square" type="date"  placeholder="" name="registration_date" formControlName="registration_date" [(ngModel)]="registration_date" datetime="yyyy-MM-dd">										
									</div>	
									<div class="col-md-3 mb-3">
										<label >Pan Number</label>
										<input class="form-control btn-square" type="text" placeholder="" name="pan_number" formControlName="pan_number" [(ngModel)]="pan_number">										
									</div>
								<!--	<div class="col-md-3 mb-3">
										<label >GSTIN Number</label>
										<input class="form-control btn-square" type="text" placeholder="" name="vendor_legal_name" required>										
									</div>									-->
								</div>
										
							</div>
						</div>	
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Company Contact and Media Information</h5>
							</div>
							<div class="card-body">								
								<div class="row">										
									<div class="col-md-3 mb-3">
										<label >Office Phone *</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="phone" formControlName="phone" required [(ngModel)]="phone">	
										<div *ngIf="next2Clicked  && cForm.controls['phone'].errors" >	
											<div *ngIf="cForm.controls['phone'].errors?.['required']" class="text text-danger" > Office Phone is required</div>								
										</div>	
									</div>
									<div class="col-md-3 mb-3">
										<label >Office Email *</label>
										<input class="form-control btn-square" type="text" placeholder="" name="office_email" formControlName="office_email" required [(ngModel)]="office_email">	
										<div *ngIf="next2Clicked"  >
											<div *ngIf="cForm.controls['office_email'].errors?.['required']" class="text text-danger">Email address is required</div>
											<div *ngIf="cForm.controls['office_email'].errors?.['pattern']" class="text text-danger" >Email is Invalid</div>
										</div>										
									</div>
									<div class="col-md-3 mb-3">
										<label >Accounts Phone</label>
										<input class="form-control btn-square" type="text" placeholder="" name="accounts_phone" formControlName="accounts_phone"  [(ngModel)]="accounts_phone">										
									</div>
									<div class="col-md-3 mb-3">
										<label>Accounts Email</label>
										<input class="form-control btn-square" type="text" placeholder="" name="accounts_email" formControlName="accounts_email" [(ngModel)]="accounts_email">										
									</div>									
									<div class="col-md-3 mb-3">
										<label >Website</label>
										<input class="form-control btn-square" type="text" placeholder="" name="web_url" formControlName="web_url" [(ngModel)]="web_url">										
									</div>									
									<div class="col-md-3 mb-3">
										<label >Insta</label>
										<input class="form-control btn-square" type="text" placeholder="" name="insta" formControlName="insta" [(ngModel)]="insta">										
									</div>
									<div class="col-md-3 mb-3">
										<label >LinkedIn</label>
										<input class="form-control btn-square" type="text" placeholder="" name="linkedin" formControlName="linkedin" [(ngModel)]="linkedin">										
									</div>									
								</div>
										
							</div>
						</div>	
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Billing Name and Address</h5>
							</div>
							<div class="card-body">
							<div class="row">
									<div class="col-md-3 mb-3">
										<label>Billing Name</label>	
										<input class="form-control btn-square"  type="text" placeholder="" formControlName="billing_name" name="billing_name" #billing_name>
									</div>
									<div class="col-md-3 mb-3">
										<label>GSTIN Number</label>	
										<input class="form-control btn-square"  type="text" placeholder="" name="gstin_number" formControlName="gstin_number">
									</div>
									</div>
								<div class="row">
									<div class="col-md-3 mb-3">
										<label>Address Line1</label>	
										<input class="form-control btn-square"   type="text" placeholder="" formControlName="billing_addressline1" name="billing_addressline1" [(ngModel)]="billing_addressline1">
									</div>
									<div class="col-md-3 mb-3">
										<label>Address Line2</label>	
										<input class="form-control btn-square"  type="text" placeholder="" formControlName="billing_addressline2" name="billing_addressline2" [(ngModel)]="billing_addressline2">
									</div>
									<div class="col-md-3 mb-3">
										<label >Street No</label>
									   <input class="form-control btn-square"  type="text" placeholder="" formControlName="billing_street_no" name="billing_street_no" [(ngModel)]="billing_street_no"> 	
									</div>
									<div class="col-md-3 mb-3">
										<label >Street Name</label>
										<input class="form-control btn-square"  type="text" placeholder="" formControlName="billing_street_name" name="billing_street_name" [(ngModel)]="billing_street_name">                                
									</div>									
									<div class="col-md-3 mb-3">
										<label >Area</label>
										<input class="form-control btn-square" type="text" formControlName="billing_area" name="billing_area" placeholder="" required [(ngModel)]="billing_area">											
										<div *ngIf="next2Clicked  && cForm.controls['billing_area'].errors" >	
											<div *ngIf="cForm.controls['billing_area'].errors?.['required']" class="text text-danger" > Area is required</div>								
										</div>
									</div>
									<div class="col-md-3 mb-3">
										<label >Zip</label>
										<input class="form-control btn-square" type="text" placeholder="" formControlName="billing_zip" name="billing_zip" required [(ngModel)]="billing_zip">                               
										<div *ngIf="next2Clicked  && cForm.controls['billing_zip'].errors" >	
											<div *ngIf="cForm.controls['billing_zip'].errors?.['required']" class="text text-danger" > ZIP is required</div>								
										</div>
									</div>
									<div class="col-md-3 mb-3">
										<label >Region</label>
										<input class="form-control btn-square" type="text" formControlName="billing_region" name="billing_region" placeholder="" [(ngModel)]="billing_region">	 
									</div>
									<div class="col-md-3 mb-3">
										<label >Province</label>
										<select class="form-control btn-square" name="billing_stateshort" formControlName="billing_stateshort" placeholder=""  required (change)="getState($event);" [(ngModel)]="billing_stateshort">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let state of countryProvinces"  value={{state.shortname}}>{{state.longname}}</option> 
										</select>	 
										<div *ngIf="next2Clicked  && cForm.controls['billing_stateshort'].errors" >	
											<div *ngIf="cForm.controls['billing_stateshort'].errors?.['required']" class="text text-danger" > State is required</div>								
										</div>
									</div>
									<div class="col-md-3 mb-3">
										<label >Country</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="billing_country"   value={{country}} [disabled]=true >                                
									</div>
								</div>
							</div>			
						</div>												
						<div class="row">                            
							<div class="col-md-12 mb-3" style="text-align:right;">
								<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(1)">Back</button>&nbsp;&nbsp;<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(2)">Next</button>									
							</div>									
						</div>
						</form>
						</div>																																																								
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends -->